/* unplugin-vue-components disabled */import { render } from "./question.vue?vue&type=template&id=10df30f4&scoped=true"
import script from "./question.vue?vue&type=script&lang=js"
export * from "./question.vue?vue&type=script&lang=js"

import "./question.vue?vue&type=style&index=0&id=10df30f4&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10df30f4"],['__file',"src/components/chat-input-v2/question/question.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "10df30f4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('10df30f4', __exports__)) {
    api.reload('10df30f4', __exports__)
  }
  
  module.hot.accept("./question.vue?vue&type=template&id=10df30f4&scoped=true", () => {
    api.rerender('10df30f4', render)
  })

}


export default __exports__